







































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import ListViewItem from "list-view/src/listviewitem";
import NewsModel from "@views/a-model/news-model";
import DefaultModel from "@views/a-model/default-model";
import ControlValidatorGroupComponent from "../components/control-validator-group.vue";
import iOrganization from "../a-model/interfaces/iOrganization";
import iMobileDeviceUser from "../a-model/interfaces/iMobileDeviceUser";
import iMarket from "../a-model/interfaces/iMarket";
import { EnumTerminaleType } from "../a-model/enum/EnumTerminaleType";
import { EnumRoleType } from "../a-model/enum/EnumRoleType";
import EnumMobileRoles from "../../dataSource/api/RunPay/Admin/IServices/Enums/EnumMobileRoles";


//MAXI MINI WEB Andriod tablet

@Component({
  name: "organization",
  components: {}
})
export default class OrganizationComponent extends Vue {
  currentRolleId: String = null;
  currentUserId: String = null;

  userId=""
  terminaleCode=""

  pageSize = 10;
  currentPage = 0;
  totalItems = 5;
  user:iMobileDeviceUser = null
  organization:iOrganization =null
  modalWindowShow = false;

  devices:ListViewItem<DefaultModel>[] = [];

  search = "";
  Items: iMarket[] = [];
  innerItems: iMarket[] = [];
  newMarket:iMarket = null;

  created() {
    document.title = this.$route.meta.title;
    this.getOrganization(this.$route.params.idOrganization)

    this.getUser(this.$route.params.idUser);
  }

  /*возвращаемся на страницу списка пользователей */
  goMobileDeviceUsers(){
    this.$router.push({ path: '/contracts' })
  }

  /*получаем информацию о пользователе */
  getUser(userId:string){
    this.user={id:"1", name:"Ivanov Ivan Ivanovich",role:EnumMobileRoles.None,email:"test@.gmail.com",dateCreate:new Date()}
  }

  getOrganization(userId:string){
    this.$api.ContractService.GetSingleContractEvent.once(response=>{
      if (!response.IsSuccess) {
        return
      }
      this.organization={
        id            :response.Value.Id             != null ? response.Value.Id.toString():"",
        inn           :response.Value.INN            != null ? response.Value.INN.toString():"",
        name          :response.Value.EnterpriseName != null ? response.Value.EnterpriseName.toString():" ",
        address       :response.Value.Address        != null ? response.Value.Address.toString():"",
        phone         :response.Value.Phone          != null ? response.Value.Phone.toString():"",
        email         :response.Value.Email          != null ? response.Value.Email.toString():"", 
        region        :response.Value.RegionId       != null ? response.Value.RegionId.toString():"",
        typeContract  :response.Value.ContractType ,
        countShop     :0,
        countPoint    :0,
        clientName    :response.Value.ContractType.toString(),
        pdfLink       :""
      }
      this.getDevices({ Take: this.pageSize, Skip: this.currentPage });
    })
    this.$api.ContractService.GetSingleContract(parseInt(this.$route.params.organizationId))
  }

  onSearch() {
    this.getDevices({ Take: this.pageSize, Skip: this.currentPage });
  }

  getDevices({ Skip, Take }: { Skip: number; Take: number }) {
    this.Items = [];
    this.$api.ContractService.GetPaginatedShopsListEvent.once(response=>{
      if (!response.IsSuccess) {
        return;
      }

      this.totalItems = response.Value.Count;
      this.innerItems = [];
      this.innerItems = response.Value.Items.map(item=>({
        id:item.Id.toString(),
        name:item.ShopName!=null?item.ShopName.toString():"",
        address:item.Address!=null?item.Address.toString():"",
        terminaleType:item.TerminalType.toString(),
        
        // terminaleCode:item.TerminalCode.toString(),
        location:{latitude:item.Latitute!=null?item.Latitute.toString():"",longitude:item.Longitute!=null?item.Longitute.toString():""}
      }))
    })
    this.$api.ContractService.GetPaginatedShopsList({ContractId:parseInt(this.organization.id),Search:this.search,Skip:Skip,Take:Take })
  }

  isValid(): boolean {
    return ((this.$refs.validator as ControlValidatorGroupComponent).isValid());
  }

  getContractsName(contractType:number):string{
    switch (contractType) {
      case 1:
        return "credit"
        break;
      case 2:
        return "deposit"
        break;

      default:
        break;
    }
  }

  getRoleName(role: number) {
    switch (role) {
      case 0:
        return "Не выбрано";
        break;
      case 1:
        return "Инкасатор";
        break;
      case 2:
        return "Рег.Менеджер";
        break;
      case 3:
        return "Техник";
        break;

      default:
        break;
    }
  }

  getTerminaleName(terminaleType: string) {
    
    switch (terminaleType) {
      case "0":
        return "MINI";
        break;
      case "1":
        return "MAXI";
        break;
      case "2":
        return "WEB";
        break;
      case "3":
        return "TABLETANDROID";
        break;

      default:
        break;
    }
  }
 
  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.getDevices({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage
    });
  }

  onShowWindowAddDevice() {
    
    this.modalWindowShow = true;
  }

  closeModalWindow() {
    this.modalWindowShow = false;

  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case "id":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.id > b.id ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.id < b.id ? 1 : -1;
          });
          break;
        }
      case "name":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.name < b.name ? 1 : -1;
          });
          break;
        }
      case "address":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.address > b.address ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.address < b.address ? 1 : -1;
          });
          break;
        }
      case "terminaleType":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.terminaleType > b.terminaleType ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.terminaleType < b.terminaleType ? 1 : -1;
          });
          break;
        }
      case "terminaleCode":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.terminaleCode > b.terminaleCode ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.terminaleCode < b.terminaleCode ? 1 : -1;
          });
          break;
        }
         case "location":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.location.latitude > b.location.latitude ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.location.latitude < b.location.latitude ? 1 : -1;
          });
          break;
        }
      default:
        break;
    }
  }
 async onDisconnectDeviceFromUser(deviceId:string){
  var res = await this.$dialog
        .confirm(this.$locale.getTranslate('areYouSureYouWantToDisconnectTheDevice'))
        .then((res: boolean) => {
          if (res) {
            this.$api.ContractService.RemoveTerminalEvent.once(response=>{
              if (!response.IsSuccess) {
                return;
              }
              this.getDevices({ Take: this.pageSize, Skip: this.currentPage });
            })
            this.$api.ContractService.RemoveTerminal(parseInt(deviceId))
          }
          if (res == false) {
          }
        });
    }

 
onOpenWindowConnectDeviceToUser(userId:string,userName:string){
     this.userId = userId;
     this.userName=userName
     this.getTerminale(this.userId.toString(),"")
     this.modalWindowShow =true;
  }

  onConnectDeviceToUser(){
    if (this.devices.filter(el=>el.Selected==true).length>0){
      this.connectTerminale(this.userId.toString(), this.devices.filter(el=>el.Selected==true)[0].Value.id)
      this.closeModalWindow();
    }
    else{
      this.$dialog.alert("Выберите код устройства!")
    }
  }

  changeAutocomlite(serchTermit:string){
    this.getTerminale(this.userId.toString(),serchTermit)
  }

  /*
    проверяем терминал на существование
  */
  getTerminale(terminaleCode:string,search:string):Boolean
  {
    this.$api.UserMobileService.GetTerminalsForAddingEvent.once(response=>{
      if (!response.IsSuccess) {
        return false
      }
      this.devices=[];
      response.Value.forEach(element => {
        this.devices.push(new ListViewItem(new DefaultModel(element.Id,element.Code.toString()),false,false))
      });
    })
    this.$api.UserMobileService.GetTerminalsForAdding({UserId:parseInt(this.userId.toString()),Search:search});

return true
  }

  /*
    подключаем терминал
  */
  connectTerminale(userId:string,terminaleCode:string){
    this.$api.UserMobileService.AddTerminalToUserEvent.once(response=>{
      if (!response.IsSuccess) {
        this.$dialog.alert("Проверьте код устройства!")
        return
      }
      this.$dialog.success("Устройство успешно добавлено!")
      this.devices=[];
      this.getTerminale(this.userId.toString(),"")
    })
    this.$api.UserMobileService.AddTerminalToUser({UserId:parseInt(userId),TerminalId:parseInt(terminaleCode)})
  }
        
  
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-contracts-organization.vue